import { createStyles } from 'antd-style';
import React, { ReactElement } from 'react';

const useStyles = createStyles(() => ({
  // Table of Contents
  olToc: {
    marginBottom: '0',
    paddingLeft: '0',
    // Make space for page numbers in PDF
    paddingRight: '30px',
    li: {
      listStyleType: 'none',
      a: {
        color: 'inherit',
        textDecoration: 'none',
        ':hover': {
          textDecoration: 'underline'
        }
      },
      '&.Toc1': {
        marginLeft: '0',
        fontSize: '11pt',
        fontFamily: "'Arial', 'sans-serif'",
        ['textTransform' as never]: 'uppercase',
        fontWeight: 600
      },
      '&.Toc2': {
        marginLeft: '0.25in',
        fontSize: '10pt',
        fontVariant: 'small-caps',
        ['textTransform' as never]: 'uppercase',
        fontWeight: 600
      },
      '&.Toc3': {
        marginLeft: '0.5in',
        fontSize: '10pt',
        fontStyle: 'italic',
        ['textTransform' as never]: 'uppercase'
      },
      '&.Toc4': {
        marginLeft: '0.7in',
        fontSize: '9pt',
        fontStyle: 'italic',
        ['textTransform' as never]: 'uppercase'
      },
      '&.Toc1, &.Toc2, &.Toc3, &.Toc4': {
        marginTop: '6pt',
        marginRight: '0in'
      }
    }
  }
}));

export type ReportSection = {
  title: string;
  id?: string;
  className?: string;
  component?: ReactElement;
  indentCount: number;
  headerOnly?: boolean;
};

type TableOfContentsProps = {
  reportSections: ReportSection[];
};

export default function TableOfContents(props: TableOfContentsProps): ReactElement {
  const { reportSections } = props;
  const { cx, styles } = useStyles();

  return (
    <div className="report-section page-break">
      <h2 className="text-uppercase">Table of Contents</h2>
      <ol id="reportTOC" className={cx(styles.olToc)}>
        {reportSections.map(section => {
          return (
            <li
              key={section.id}
              style={{
                listStyle: 'none',
                fontSize: '10pt',
                textTransform: 'uppercase',
                marginLeft: section.indentCount * 40,
                fontWeight: section.indentCount > 0 ? 'thin' : 'bold'
              }}
            >
              {section.headerOnly ? (
                <>{section.title}</>
              ) : (
                <a
                  style={{ color: 'inherit', textDecoration: 'none' }}
                  href={'#' + section.id}
                  onClick={e => {
                    e.preventDefault();
                    document.querySelector(`[id="${section.id}"]`)!.scrollIntoView();
                  }}
                >
                  {section.title}
                </a>
              )}
            </li>
          );
        })}
      </ol>
    </div>
  );
}
